// cart-upsell.js — upsells from Collection OR Search & Discovery Recommendations
(function () {
  const drawer = document.getElementById('UnifiedCartDrawer');
  if (!drawer) return;

  const mount = document.getElementById('CartUpsellProducts');
  if (!mount) return;

  // Settings passed as data-attributes from the section
  const source           = drawer.dataset.upsellSource || 'collection'; // 'collection' | 'recommendations'
  const collectionHandle = drawer.dataset.upsellCollection || '';
  const intent           = drawer.dataset.upsellIntent || 'related';    // 'related' | 'complementary'
  const limit            = Number(drawer.dataset.upsellLimit || 4);
  const layout           = drawer.dataset.upsellLayout || 'grid';       // 'grid' | 'list'

  // Apply layout class
  mount.classList.toggle('upsell-grid', layout === 'grid');
  mount.classList.toggle('upsell-list', layout === 'list');

  const seen = new Set(); // dedupe by product id

  function fmtEUR(cents) {
    const v = Math.max(0, Number(cents) || 0) / 100;
    try { return new Intl.NumberFormat('nl-NL', { style:'currency', currency:'EUR' }).format(v); }
    catch { return '€' + v.toFixed(2).replace('.', ','); }
  }

  // Minimal, safe normalization (don’t change your existing data flow)
  // - If price is a string like "9.95" -> convert to 995
  // - If price is a number (already in cents) -> keep it
  function priceToCents(raw) {
    if (typeof raw === 'string') {
      const n = parseFloat(raw.replace(',', '.'));
      return Number.isFinite(n) ? Math.round(n * 100) : 0;
    }
    const n = Number(raw);
    return Number.isFinite(n) ? n : 0;
  }

  // Prefer variant image, then fall back to product images
  function getImageSrc(product, variant) {
    return (
      variant?.featured_image?.src ||
    variant?.image?.src ||
    variant?.image ||
    product?.images?.[0]?.src ||
    product?.featured_image?.url ||
    product?.featured_image?.src ||
    product?.featured_image ||   // <— handles plain string
    product?.image?.url ||
    product?.image?.src ||
    product?.image ||  
      ''
    );
  }

  // Unified cart add (using pb-cart.js)
async function addToCart(variantId) {
  if (!window.PBCart) throw new Error('PBCart not loaded');
  try {
    const cart = await window.PBCart.addLine(variantId, 1);
    // fire same event so upsells & drawer refresh
    document.dispatchEvent(new CustomEvent('pb:cart:updated', { detail: { cart } }));
    return cart;
  } catch (err) {
    console.error('[Upsell] Failed to add', variantId, err);
    throw err;
  }
}


  function render(products) {
    // reset dedupe per render
    seen.clear();

    if (!products.length) {
      mount.innerHTML = '<p>Geen aanbevelingen beschikbaar.</p>';
      return;
    }

    mount.innerHTML = products.slice(0, limit).map(p => {
      const variants = Array.isArray(p.variants) ? p.variants : [];
      const initVariant =
        variants.find(v => v && v.available !== false) ||
        variants[0] ||
        {};

      const img = getImageSrc(p, initVariant);

      // NOTE: we use the same display logic as before — fmtEUR expects cents.
      // priceToCents keeps existing stores happy whether endpoint gives "9.95" or 995.
      const initPriceCents = priceToCents(initVariant?.price || 0);

      // Variant selector (only if >1 variant)
      let variantSelectHTML = '';
      if (variants.length > 1) {
        const options = variants.map(v => {
          const vId   = v?.id || '';
          const vName = v?.title || 'Variant';
          const cents = priceToCents(v?.price || 0);
          const vImg  = getImageSrc(p, v) || '';
          const disabled = v?.available === false ? 'disabled' : '';
          const selected = String(vId) === String(initVariant?.id) ? 'selected' : '';
          return `<option value="${vId}"
                          data-price-cents="${cents}"
                          data-img-src="${vImg}"
                          ${disabled} ${selected}>${vName}</option>`;
        }).join('');
        variantSelectHTML = `          
          <select class="upsell-variant" id="upsell-variant-${p.id}">
            ${options}
          </select>
        `;
      }

      return `
        <div class="upsell-card" data-id="${p.id}">
          ${img ? `<img class="upsell-img" src="${img}" alt="${p.title}">` : ''}
          <div class="upsell-info">
          <div>${p.title}</div>
          
          <div class="upsell-row">
            <p class="upsell-price" data-fallback="${initPriceCents}">
              ${fmtEUR(initPriceCents)}
            </p>
            <div class="upsell-select">
              ${variantSelectHTML}
            </div>
          </div>
          <button data-variant-id="${initVariant?.id || ''}" class="upsell-add">
  <span class="ucd-btn-label">In Winkelwagen</span>
  <span class="ucd-spinner" aria-hidden="true" style="display:none"></span>
</button>

        </div>

        </div>
      `;
    }).join('');

    // Bind events after rendering
    mount.querySelectorAll('.upsell-card').forEach(card => {
      const btn    = card.querySelector('.upsell-add');
      const price  = card.querySelector('.upsell-price');
      const imgEl  = card.querySelector('.upsell-img');
      const select = card.querySelector('.upsell-variant');

      if (btn) {
  btn.addEventListener('click', async () => {
    const vid = btn.dataset.variantId;
    if (!vid) return;

    const label = btn.querySelector('.ucd-btn-label');
    const spin  = btn.querySelector('.ucd-spinner');

    btn.disabled = true;
    btn.classList.add('is-loading');
    if (spin)  spin.style.display = 'inline-block';

    try {
      await addToCart(vid);
      if (label) label.textContent = 'Added ✓';
      // brief success, then restore
      setTimeout(() => {
        if (label) label.textContent = 'In Winkelwagen';
      }, 700);
    } catch (e) {
      if (label) label.textContent = 'Try again';
      setTimeout(() => {
        if (label) label.textContent = 'In Winkelwagen';
      }, 1200);
    } finally {
      btn.disabled = false;
      btn.classList.remove('is-loading');
      if (spin) spin.style.display = 'none';
    }
  });
}



      if (select) {
        select.addEventListener('change', () => {
          const opt = select.options[select.selectedIndex];
          // Update price
          const cents = Number(opt?.dataset?.priceCents || price?.dataset?.fallback || 0);
          if (price) price.textContent = fmtEUR(cents);
          // Update add-to-cart target variant
          if (btn) btn.dataset.variantId = select.value || '';
          // Update image to selected variant image (fallback no-op)
          const variantImg = opt?.dataset?.imgSrc || '';
          if (imgEl && variantImg) imgEl.src = variantImg;
        });
      }
    });
  }

  // ---------- DATA SOURCES ----------
  // A) Collection (existing behavior)
  function fetchCollection(handle) {
    return fetch(`/collections/${handle}/products.json?limit=${encodeURIComponent(limit)}`)
      .then(r => r.json())
      .then(d => d.products || []);
  }

  // B) Search & Discovery recommendations
  // Endpoint: /recommendations/products.json?product_id=###&limit=&intent=
  const recCache = new Map();
  function fetchRecommendations(productId) {
    if (!productId) return Promise.resolve([]);
    if (recCache.has(productId)) return recCache.get(productId);

    const url = `/recommendations/products.json?product_id=${productId}&limit=${Math.max(4, limit)}&intent=${intent}`;
    const p = fetch(url).then(r => r.json()).then(d => d.products || []);
    recCache.set(productId, p);
    return p;
  }

  function fetchCart() { return fetch('/cart.js', { credentials:'same-origin' }).then(r => r.json()); }

  function uniqueById(items) {
    const out = [];
    for (const p of items) {
      if (!p || !p.id) continue;
      if (!seen.has(p.id)) { seen.add(p.id); out.push(p); }
    }
    return out;
  }

  // Build a list from recommendations of items in cart
  async function loadFromRecommendations() {
    const cart = await fetchCart();
    const inCartIds = new Set((cart.items || []).map(i => i.product_id));

    // pull recs for each cart product (stop once we have enough)
    const batches = [];
    for (const line of (cart.items || [])) {
      batches.push(fetchRecommendations(line.product_id));
    }
    const all = (await Promise.all(batches)).flat();

    // filter: not already in cart, dedupe, and keep availability
    const filtered = uniqueById(
      all.filter(p => !inCartIds.has(p.id) && (p.available !== false))
    );

    // If we still have nothing (e.g., empty cart), fall back to collection if configured
    if (!filtered.length && collectionHandle) {
      return fetchCollection(collectionHandle);
    }
    return filtered;
  }

  // ---------- INIT ----------
  function init() {
    if (source === 'recommendations') {
      loadFromRecommendations().then(render).catch(() => render([]));
    } else {
      // default: collection
      fetchCollection(collectionHandle).then(render).catch(() => render([]));
    }
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('cart:updated', init); // refresh recs when cart changes
})();
